import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const DevSettings = withLazyFallback(
  () => import('components/admin/pages/DevSettings/DevSettings')
);
const FeatureFlags = withLazyFallback(
  () => import('components/admin/pages/DevSettings/components/FeatureFlags/FeatureFlags')
);

const ADMIN_DEV_SETTINGS = [
  {
    path: 'dev-settings',
    element: <DevSettings />,
    children: [{ path: 'feature-flags', element: <FeatureFlags /> }]
  }
];

export default ADMIN_DEV_SETTINGS;
